<template>
  <div>
    <!-- <h2 class="text-center colorblue">Панель оператора</h2> -->
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        dense
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <!-- <v-toolbar-title>Панель оператора</v-toolbar-title> -->
            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
            <!-- <v-spacer></v-spacer> -->
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Найти"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:item.IP="{ item }">0.0.0.0 01.01.2020 </template>
        <template v-slot:item.orgNameINN="{ item }"
          >{{ item.orgName }} {{ item.inn }}
        </template>
        <template v-slot:item.type="{ item }"
          >{{ getPrav(item.pravForm) }}
        </template>
        <template v-slot:item.active="{ item }">
          <template v-if="item.active">
            <v-chip
              x-small
              :color="getColor(item.active)"
              class="white--text"
              >{{ getBool(item.active) }}</v-chip
            >
          </template>
          <template v-else>
            <v-chip x-small :color="getColor(item.active)">{{
              getBool(item.active)
            }}</v-chip>
          </template>
        </template>
        <template v-slot:item.famil="{ item }"
          >{{ item.famil }} {{ item.profile_name }} {{ item.otch }}</template
        >

        <template v-slot:item.calc="{ item }">{{moment(item.email_verified_at).format('DD.MM.YYYY')}}</template>
        <template v-slot:item.reestr="{ item }">31.05.2020</template>
        <template v-slot:item.role="{ item }">{{getRoleName(item.role)}}</template>

        <template v-slot:item.action="{ item }">
          <v-btn x-small color="blue-grey" class="ma-2 white--text">
            Повторное письмо
            <v-icon right dark>mail</v-icon>
          </v-btn>
          <v-btn x-small color="grey">
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Globalrules from "../components/api/rules.js";
import moment  from 'moment'


export default {
  components: {},
  data() {
    return {
      moment,
      items: [],
      rules: Globalrules,
      search: "",
      activeBtn: 2,
      showNav: true,
      valid: true,
      dialog: false,
      dialog2: false,
      headers: [
        { text: "IP адрес / Дата входа", value: "IP" },
        { text: "Наименование организации / ИНН", value: "orgNameINN" },
        { text: "Тип пользователя", value: "type" },
        { text: "Фамилия Имя Отчество", value: "famil" },
        { text: "Активный", value: "active" },
        { text: "Телефон", value: "phone" },
        { text: "Email", value: "emailContact" },
        { text: "Доступ к калькулятору", value: "calc" },
        { text: "Доступ к реестру победителей", value: "reestr" },
        { text: "Роль", value: "role" },
        { text: "Дата Регистрации", value: "created_at" },
        { text: "Дата Активации", value: "email_verified_at" },
        { text: "Действия", value: "action" },
      ],
    };
  },

  filters: {
    toBool(val) {
      if (val) return "Да";
      else return "Нет";
    },
  },

  methods: {
    getPrav(val) {
      switch (val) {
        case "1":
          return "ЮЛ";
        case "2":
          return "ИП";
        case "3":
          return "СЗ";
      }
    },
    getBool(val) {
      if (val) return "Да";
      else return "Нет";
    },
    getColor(color) {
      if (color) return "red";
      return "transparent";
    },
    initialize() {
      this.$store.dispatch("getUsersForOperatorPanel").then(() => {
        this.items = this.$store.getters.GetUsersOperator;
      });
    },
  },

  created() {
    this.initialize();
  },
  mounted() {
    this.setTitle("Панель оператора");
  },
};
</script>

<style lang="scss"></style>
